import React from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import { ErrorOutline as ErrorOutlineIcon } from '@mui/icons-material';

const ErrorState = ({ message, onRetry, loading }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        minHeight: '200px',
        textAlign: 'center',
        backgroundColor: 'background.paper',
        borderRadius: 2,
        padding: 2,
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 50, color: 'red' }} />
      <Typography variant="h6" color="text.secondary" sx={{ marginTop: 2 }}>
        {message || 'Something went wrong! Please try again.'}
      </Typography>
      <Box mt={2}>
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <Button
            variant="contained"
            color="secondary"
            onClick={onRetry}
            sx={{ marginTop: 2 }}
          >
            Retry
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ErrorState;